import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]

import { withDefaults } from "vue"

interface Props {
    class?: string
    fill?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CaretIcon',
  props: {
    class: { default: "" },
    fill: { default: "none" }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    class: _normalizeClass(props.class),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M6 6L14 10L6 14V6Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})